import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent {
  @Output() back = new EventEmitter<void>();

  cancel()  {
    this.back.emit();
  }
}
